import { Outlet } from "react-router-dom";
import LicenseManager from "../License/LicenseManager";
import NavWrapper from "./NavWrapper";
import "./Nav.scss"

const Navbar = () => {
  return (
    <section className="relative grow flex flex-col">
      <NavWrapper />
      <Outlet />
      <LicenseManager />
    </section>
  );
};

export default Navbar;